import clsx from 'clsx'
import { useEffect, useState } from 'react'

const LOADING_MESSAGES = [
  'Making coffee',
  'Configuring models',
  'Structuring data',
  'Calculating quartiles',
  'Serving coffee',
  'Heading to light speed',
  'Pondering realities',
  'Slowing down',
  'Rethinking approach',
  'Looking at cat photos',
  'Politely excusing ourselves from social obligations',
  'Walking the dog',
  'Training model',
  'Checking label data',
  'Finding the database',
]

const getRandomMessageIndex = (currentIndex?: number): number => {
  const index = Math.floor(Math.random() * LOADING_MESSAGES.length)

  if (index === currentIndex) {
    return getRandomMessageIndex(currentIndex)
  }
  return index
}
export function LoadingScreen() {
  const [activeMessageIndex, setActiveMessageIndex] = useState(
    getRandomMessageIndex()
  )

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveMessageIndex(getRandomMessageIndex)
    }, 3000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        style={{
          background: 'none',
          display: 'block',
          shapeRendering: 'auto',
        }}
        width="200px"
        height="200px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <circle
          cx="50"
          cy="50"
          r="0"
          fill="none"
          stroke="#033673"
          strokeWidth="2"
        >
          <animate
            attributeName="r"
            repeatCount="indefinite"
            dur="2.127659574468085s"
            values="0;40"
            keyTimes="0;1"
            keySplines="0 0.2 0.8 1"
            calcMode="spline"
            begin="0s"
          />
          <animate
            attributeName="opacity"
            repeatCount="indefinite"
            dur="2.127659574468085s"
            values="1;0"
            keyTimes="0;1"
            keySplines="0.2 0 0.8 1"
            calcMode="spline"
            begin="0s"
          />
        </circle>
        <circle
          cx="50"
          cy="50"
          r="0"
          fill="none"
          stroke="#888888"
          strokeWidth="2"
        >
          <animate
            attributeName="r"
            repeatCount="indefinite"
            dur="2.127659574468085s"
            values="0;40"
            keyTimes="0;1"
            keySplines="0 0.2 0.8 1"
            calcMode="spline"
            begin="-1.0638297872340425s"
          />
          <animate
            attributeName="opacity"
            repeatCount="indefinite"
            dur="2.127659574468085s"
            values="1;0"
            keyTimes="0;1"
            keySplines="0.2 0 0.8 1"
            calcMode="spline"
            begin="-1.0638297872340425s"
          />
        </circle>
      </svg>

      <div className="relative left-0 top-0 flex w-full justify-center whitespace-nowrap">
        {LOADING_MESSAGES.map((lm, i) => (
          <h3
            key={lm}
            className={clsx('absolute transition-opacity', {
              'opacity-0': activeMessageIndex !== i,
              'opacity-100': activeMessageIndex === i,
            })}
          >
            {lm}
          </h3>
        ))}
      </div>
    </div>
  )
}
